enum OfficeFormType {
  name,
  company,
  email,
  webUrl,
  webLabel,
  lunchEnabled,
  qrCodeEnabled,
  isFloorPlanAvailable,
  floorPlanEnabled,
  reservableThroughFloorplanEnabled,
  weblink,
  maxCapacity,
  isMaxCapacityTheLimit,
  planPeriodDays,
  bookingTimeZone,
  addPermittedUser,
  addPermittedUserName,
  updatePermittedUser,
  addPermittedAdmin,
  deletePermittedAdmin,
  deleteEmail,
  addRoom,
  addDepartmentToRooms,
  deleteRoom,
  updateRoom,
  addDepartment,
  deleteDepartment,
  updateDepartment,
  capacity,
  memberCount,
  notificationDay,
  notificationTime,
  groupReservationsEnabled,
  maximumGroupSize,
  maximumGroupLeaders,
  groupPlanPeriodDays,
  isAvailableInApp,
  cateringNotificationEnabled,
  cateringNotificationEmailSubject,
  cateringNotificationEmailBody,
  cateringNotificationRecipients,
  cateringNotificationSendTime,
  cateringNotificationTimeZone,
  cateringNotificationDaysAhead,
  officeThresholdMinPercentage,
  officeThresholdMaxPercentage,
  roomThresholdMinPercentage,
  roomThresholdMaxPercentage,
  parkingThresholdMinPercentage,
  parkingThresholdMaxPercentage,
}

export default OfficeFormType;
